import React from "react";
import { useTranslation } from "../../i18n/TranslationProvider";
import { useHistory, useLocation } from "react-router-dom";
import SubmitButton from "../UIComponents/SubmitButton";

const Warning = ({ user }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const symptom = location.state.symtom;

  if (!user || !symptom) history.goBack();
  return (
    <>
      <h3>{t("warning.hi")}{user.firstName},</h3>
      <p>
        {t("warning.body.0")}{symptom}{t("warning.body.1")}
      </p>
      <p>{t("warning.body.2")}</p>
      <p>{t("warning.body.3")}</p>
      <p>{t("warning.body.4")}</p>

      <h3>{t("warning.adults.header")}</h3>
      <ul>
        <li>{t("warning.adults.1")}</li>
        <li>{t("warning.adults.2")}</li>
        <li>{t("warning.adults.3")}</li>
        <li>{t("warning.adults.4")}</li>
        <li>{t("warning.adults.5")}</li>
        <li>{t("warning.adults.6")}</li>
        <li>{t("warning.adults.7")}</li>
        <li>{t("warning.adults.8")}</li>
        <li>{t("warning.adults.9")}</li>
        <li>{t("warning.adults.10")}</li>
        <li>{t("warning.adults.11")}</li>
        <li>{t("warning.adults.12")}</li>
      </ul>

      <h3>{t("warning.children.header")}</h3>
      <span>{t("warning.children.intro")} </span>
      <ul>
        <li>{t("warning.children.1")}</li>
        <li>{t("warning.children.2")}</li>
        <li>{t("warning.children.3")}</li>
        <li>{t("warning.children.4")}</li>
      </ul>
      <SubmitButton onClick={() => history.push("/")}>{t("warning.go_back")}</SubmitButton>
    </>
  );
};

export default Warning;